import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router';
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import moment from 'moment';
import Select from 'react-select';

const CheckinPointCampaign = (props) => {
  const { user } = props;
  const { siteId, mallId } = useParams();
  const [campaignData, setCampaignData] = useState(null);
  const [scheduleData, setScheduleData] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();

  const [values, setValues] = useState({
    site_id: siteId,
    point_campaign_id: null,
    mall_id: mallId,
    point_campaign_name: '',
    start_date: null,
    end_date: null,
    schedule_id: null,
    magnification: null,
  });
  const PAGE_SIZE = 5;

  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const refreshData = useCallback(async () => {
    setLockData(true);
    var resdata = null;
    try {
      //トークンを取得
      const jwt = localStorage.getItem('jwt');

      resdata = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/checkin_point_campaign/search`, { site_id: siteId, mall_id: mallId }, { headers: { Authorization: `Bearer ${jwt}` } })).data;
      if (Array.isArray(resdata) && resdata.length > 0){
        const processedData = resdata.map((item) => ({
          site_id: siteId,
          mall_id: mallId,
          point_campaign_id: item.point_campaign_id || null,
          point_campaign_name: item.point_campaign_name || null,
          start_date: item.start_date || null,
          end_date: item.end_date || null,
          schedule_id: item.schedule_id || null,
          magnification: item.magnification || null,
          upd_date: item.upd_date || null,
        }));

        setCampaignData(processedData);
      } else {
        // resdataが空の場合の処理
        setCampaignData([]);
      }

      var scheduleData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/schedule/${siteId}/${mallId}`, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      })).data;
      setScheduleData(scheduleData);

    } catch (error) {
      console.error(error);
      setCampaignData([]);
    } finally {
      setLockData(false);
    }
  }, [siteId, mallId]);

  /* DB更新 */
  const handleRegistClick = async () => {
    const jwt = localStorage.getItem('jwt');
    if (!values.point_campaign_name || values.point_campaign_name.trim() === "") {
      window.alert('キャンペーン名を入力してください。');
      return;
    }
    if (!values.start_date || !values.end_date) {
      window.alert('キャンペーン期間を入力してください。');
      return;
    }
    if (moment(values.start_date) > moment(values.end_date)) {
      window.alert('キャンペーン期間が間違っています。');
      return;
    }
    if (!values.magnification) {
      window.alert('ポイント倍率を入力してください。');
      return;
    }
    if (!/^[1-9]\d*$/.test(values.magnification)) {
      window.alert('ポイント倍率は正の整数で入力してください。');
      return;
    }
    var params = structuredClone(values);
    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = siteId;
    params.mall_id = mallId;

    if (!window.confirm(`登録してよろしいですか？`)) {
      return;
    }

    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/checkin_point_campaign/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      });
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }
  /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`キャンペーン[${data.point_campaign_id}:${data.point_campaign_name}]を削除します。\nよろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      point_campaign_id: data.point_campaign_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/checkin_point_campaign/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }
  /* 編集ボタン押下 */
  const handleUpdateClick = (data) => {
    const data1 = structuredClone(data)
    setValues(data1);
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      site_id: siteId,
      point_campaign_id: null,
      mall_id: mallId,
      point_campaign_name: '',
      start_date: null,
      end_date: null,
      schedule_id: null,
      magnification: null,
    });
  }

  const scheduleOptions = scheduleData ? scheduleData.map(schedule => ({
    value: schedule.schedule_id,
    label: schedule.schedule_name,
  })) : [];

  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || values.point_campaign_name === ''}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || values.point_campaign_id === null}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  const handleChange = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  const handleChangeDate = (name, value) => {
    if (name === "end_date") {
      // 終了日は23:59:59にする
      value = moment(value).endOf('day').toDate();
    } else {
      // 開始日は00:00:00にする
      value = moment(value).startOf('day').toDate();
    }
    setValues({ ...values, [name]: value });
  }

  useEffect(() => {
    refreshData();
  }, [refreshData]); //

  const renderInput = () => {
    return (
      <div className="mx-1">
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>キャンペーンID</span>
          </div>
          <div className="col-2 text-center align-self-center">
            <input type="text" className="form-control" name="point_campaign_id" defaultValue={values.point_campaign_id} placeholder="新規" readOnly />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>キャンペーン名</span>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" name="point_campaign_name" value={values.point_campaign_name} onChange={handleChange} placeholder="キャンペーン名を入力してください" />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="campaignStart">キャンペーン開始日</label>
          </div>
          <div className="col-3 text-center align-self-center">
            <DatePicker className="custom-select w-100 text-center border-textbox text-primary font-weight-bold" aria_labal="キャンペーン開始日" locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id="start_date" name="start_date"
              selected={values.start_date ? new Date(values.start_date) : null}
              maxDate={values.end_date ? new Date(values.end_date) : null}
              onChange={date => handleChangeDate("start_date", date ? date : null)}
              placeholderText="- 選択 -"
              onFocus={(e) => e.target.blur()}
            />
          </div>
          <div className="col-2 text-center align-self-center">
            <label htmlFor="campaignEnd">キャンペーン終了日</label>
          </div>
          <div className="col-3 text-center align-self-center">
            <DatePicker className="custom-select w-100 text-center border-textbox text-primary font-weight-bold" aria_labal="キャンペーン開始日" locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id="end_date" name="end_date"
              selected={values.end_date ? new Date(values.end_date) : null}
              minDate={values.start_date ? new Date(values.start_date) : null}
              onChange={date => handleChangeDate("end_date", date ? date : null)}
              placeholderText="- 選択 -"
              onFocus={(e) => e.target.blur()}
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="schedule">適用スケジュール</label>
          </div>
          <div className="col-5 align-self-center">
            <Select
              options={scheduleOptions}
              onChange={option => setValues({ ...values, schedule_id: option ? option.value : null })}
              placeholder="- 選択 -"
              isClearable={true}
              value={scheduleOptions.find(option => option.value === values.schedule_id) || null}
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="magnification">ポイント倍率</label>
          </div>
          <div className="col-5 text-left align-self-center">
            <input type="text" className="form-control" id="magnification" name="magnification" value={values.magnification || ''} onChange={handleChange} />
          </div>
        </div>
        <div className="row mb-2 pb-4">
          <div className="col-3 text-center">
            {renderRegistButton()}
          </div>
          <div className="col-3 text-center">
            {renderDeleteButton(values)}
          </div>
          <div className="col-3 text-center">
            {renderResetButton()}
          </div>
        </div>
      </div>
    );
  }

  const renderList = () => {
    const filteredData = campaignData.filter(data =>
      !searchKeyword || data.point_campaign_name.includes(searchKeyword)
    );
    const totalPages = Math.ceil(filteredData.length / PAGE_SIZE);
    const pagedData = filteredData.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

    return (
      <div className="row mb-3  mt-3 p-0">
        <div className="mr-1 text-center align-self-center">
          <span>ポイントキャンペーン(チェックイン)</span>
        </div>
        <div className="col-12 mb-2">
          <div className="row">
            <input
              type="text"
              className="col-4 form-control"
              placeholder="キャンペーン名で絞り込み"
              value={searchKeyword}
              onChange={e => { setSearchKeyword(e.target.value); setCurrentPage(1); }}
            />
          </div>
        </div>
        <div className="col-12 p-0">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <span className="small text-muted">{filteredData.length}件中 {Math.min((currentPage - 1) * PAGE_SIZE + 1, filteredData.length)}〜{Math.min(currentPage * PAGE_SIZE, filteredData.length)}件表示</span>
            {totalPages > 1 && (
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p - 1)}>‹</button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(page)}>{page}</button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p + 1)}>›</button>
                  </li>
                </ul>
              </nav>
            )}
          </div>
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  キャンペーンID
                </td>
                <td className="text-center align-middle">
                  キャンペーン名
                </td>
                <td className="text-center align-middle">
                  キャンペーン期間
                </td>
                <td className="text-center align-middle">
                  処理
                </td>
              </tr>
            </thead>
            <tbody>
              {filteredData.length === 0 && <tr><td colSpan={4} className='text-center'>データがありません</td></tr>}
              {pagedData.map((data) => (
                <tr key={data.point_campaign_id}>
                  {/* キャンペーンID */}
                  <td className="text-center align-middle">
                    {data.point_campaign_id}
                  </td>
                  {/* キャンペーン名 */}
                  <td className="text-center align-middle">
                    {data.point_campaign_name}
                  </td>
                  {/* キャンペーン期間 */}
                  <td className="text-center align-middle">
                    {moment(data.start_date).format('YYYY/MM/DD')}～{moment(data.end_date).format('YYYY/MM/DD')}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="container">

      {campaignData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {campaignData !== null && (renderList())}
      {renderInput()}
    </div>
  )
}

export default CheckinPointCampaign;